/** Angular */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
/** Sixense */
import { BydRuntimeService } from '@sixense/byd-lib-runtime';
/** Modules */
import { AppModule } from './app/app.module';
/** Models */
import { Environment } from '@core/models/environment';
/** Environment */
import { environment } from 'environments/environment';

new BydRuntimeService<Environment>(environment)
  .loadBydEnvironment()
  .subscribe((applicationEnvironment: Environment) => {
    /**
     * Set the application environment loaded from `environment.json` to `environment.ts`
     */
    environment.settings = applicationEnvironment.settings;
    environment.production = applicationEnvironment.production;
    environment.documentation = applicationEnvironment.documentation;
    environment.datadog = applicationEnvironment.datadog;

    if (applicationEnvironment.production) {
      enableProdMode();
    }
    platformBrowserDynamic()
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));
  });
